// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groupModalTitle {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.groupModalSubtitle {
  font-size: 12px;
  color: #77797b;
  font-weight: 600;
  margin-bottom: 10px;
}

.currentAdminCard {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin: 15px 0px 0px;
  background-color: #f5f5f5;
  border: 1px solid #d9dcdf;
  border-radius: 4px;
}

.currentAdminAvatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #007bc0;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}

.currentAdminInfo {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.currentAdminLabel {
  font-size: 11px;
  color: #77797b;
  text-transform: uppercase;
}

.currentAdminName {
  font-size: 14px;
  font-weight: 700;
}

.inputRow {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.groupTransferWarning {
  margin: 12px 0 0;
  padding: 10px 12px;
  background-color: #fff4ce;
  border-left: 4px solid #f6c342;
  color: #333333;
  font-size: 13px;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/ConfigGrupos/modalNovoGrupo.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".groupModalTitle {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.groupModalSubtitle {\n  font-size: 12px;\n  color: #77797b;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.currentAdminCard {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  margin: 15px 0px 0px;\n  background-color: #f5f5f5;\n  border: 1px solid #d9dcdf;\n  border-radius: 4px;\n}\n\n.currentAdminAvatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #007bc0;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.currentAdminInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.currentAdminLabel {\n  font-size: 11px;\n  color: #77797b;\n  text-transform: uppercase;\n}\n\n.currentAdminName {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.inputRow {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.groupTransferWarning {\n  margin: 12px 0 0;\n  padding: 10px 12px;\n  background-color: #fff4ce;\n  border-left: 4px solid #f6c342;\n  color: #333333;\n  font-size: 13px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
